import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next'
import { matchPath } from 'react-router'

import { DEFAULT_HOTEL_CODE } from '../common/constants'
import { ROUTES } from '../common/routes'
import { DEFAULT_LOCALE, TRANSLATION_PROJECT_IDS, TRANSLATION_TEMPLATE_IDS } from '../config/config'

const FALLBACK_LOCALE = DEFAULT_LOCALE.toUpperCase()

i18n
  .use(HttpBackend)
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring'],
      lookupQuerystring: 'locale'
    },
    supportedLngs: getSupportedLocales(),
    load: 'languageOnly',
    fallbackLng: DEFAULT_LOCALE,
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '{{lng}}',
      request: (options, lng, payload, callback) => {
        const params = new URLSearchParams({
          templateIds: TRANSLATION_TEMPLATE_IDS,
          projectIds: TRANSLATION_PROJECT_IDS,
          locales: lng === FALLBACK_LOCALE ? [FALLBACK_LOCALE] : [lng.toUpperCase(), FALLBACK_LOCALE]
        })

        fetch(`/translation-service-api/lite-translations?${params}`)
          .then(res => {
            if (!res.ok) throw new Error(`TS returned ${res.status}`)
            return res.json()
          })
          .then(data => {
            const result =
              lng === FALLBACK_LOCALE
                ? buildTranslations(data, FALLBACK_LOCALE)
                : { ...buildTranslations(data, FALLBACK_LOCALE), ...buildTranslations(data, lng) }
            callback(null, { status: 200, data: JSON.stringify(result) })
          })
          .catch(err => callback(err))
      }
    }
  })

export function buildTranslations(data, lng) {
  const result = {}
  data.forEach(({ key, localizations }) => {
    const loc = localizations.find(l => l.locale.toUpperCase() === lng.toUpperCase())
    const value = getTranslationValue(loc)
    if (value) result[key] = value
  })
  return result
}

function getTranslationValue(localization) {
  const value = localization?.value
  if (!value) return

  return value.templateId === 'UNIVERSAL' ? value.value : value
}

export function getSupportedLocales() {
  const hotelCode = matchPath(window.location.pathname, ROUTES.HOTEL)?.params.hotelCode || DEFAULT_HOTEL_CODE
  return hotelCode === 'queen' ? ['en', 'et', 'fi', 'sv'] : ['en', 'et', 'fi']
}
